export default __webpack_public_path__ + "static/media/PC_image.5fce1fe2.png";